import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrade = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={35} height={34} fill='none' {...props}>
    <rect width={34} height={34} x={0.75} fill='currentColor' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M25.25 14.375a4.875 4.875 0 0 1-5.265 4.86 4.88 4.88 0 0 0-4.47-4.47 4.875 4.875 0 1 1 9.735-.39'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M20 19.625a4.875 4.875 0 1 1-9.75 0 4.875 4.875 0 0 1 9.75 0M12.943 9.5H11a.75.75 0 0 0-.75.75v1.943c0 .667.81 1.005 1.283.532l1.942-1.942c.465-.473.135-1.283-.532-1.283M22.558 24.5H24.5c.413 0 .75-.338.75-.75v-1.943c0-.667-.81-1.005-1.282-.532l-1.943 1.943c-.465.472-.135 1.282.533 1.282'
    />
  </svg>
);
export default SvgTrade;
